// @ts-nocheck TODO: fix types for the entire file

import styled from '@emotion/styled';
import Skeleton from '@mui/material/Skeleton';
import { palette, pxToEm } from 'theme';

export const Wrapper = styled.div``;

const StyledSkeleton = styled(Skeleton)`
  background-color: ${palette.secondary.main};
  border-radius: ${pxToEm(20)};
  transform: none;
`;

export const Header = styled.div`
  padding: ${pxToEm(20)} 0 ${pxToEm(16)};
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

export const CategoryFilter = styled.div`
  display: flex;
  gap: ${pxToEm(8)};
`;

export const CategoryFilterItem = styled(StyledSkeleton)`
  width: ${pxToEm(123)};
  height: ${pxToEm(36)};
  border-radius: ${pxToEm(50)};
`;

export const CollectionsList = styled.div`
  display: flex;
  flex-direction: column;
  flex-wrap: wrap;
  gap: ${pxToEm(32)};
`;

export const CollectionCarouselImage = styled(StyledSkeleton)`
  width: ${pxToEm(332)};
  height: ${pxToEm(200)};
  flex: none;
`;

export const CollectionCarouselImages = styled.div`
  display: flex;
  gap: ${pxToEm(16)};
  overflow: hidden;
`;

export const CollectionCarousel = styled.div<{ isFeatured?: boolean }>`
  display: flex;
  flex-direction: column;
  width: 100%;

  ${({ isFeatured }) =>
    isFeatured &&
    `
    ${CollectionCarouselImage} {
      width: ${pxToEm(400)};
      height: ${pxToEm(400 / 1.67)};
    }
    
    ${CollectionCarouselImages} {
      overflow: visible;
    }
  `}
`;

export const CollectionCarouselHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: ${pxToEm(8)};
  padding: ${pxToEm(16)} 0 ${pxToEm(20)};
`;

export const CollectionCarouselTitle = styled(StyledSkeleton)`
  width: ${pxToEm(300)};
  height: ${pxToEm(36)};
`;

export const CollectionCarouselLink = styled(StyledSkeleton)`
  width: ${pxToEm(82)};
  height: ${pxToEm(36)};
`;
